import { Plus, Trash2 } from "lucide-react";

import { Button, Field } from "@/components/kit";

export const toTierS = (t) => t.map((x) => ({ min: String(x.min), max: x.max === null ? "" : String(x.max), percent: String(x.percent) }));

const num = (v) => Number(v.replace(/\s/g, "").replace(",", "."));

export function parseTiers(t) {
  if (t.some((x) => !x.min.trim() || !x.percent.trim())) throw new Error("Renseignez le minimum et le pourcentage de chaque palier");
  const out = t.map((x) => ({ min: num(x.min), max: x.max.trim() ? num(x.max) : null, percent: num(x.percent) }));
  if (out.some((x) => isNaN(x.min) || isNaN(x.percent) || (x.max !== null && isNaN(x.max)))) throw new Error("Valeurs de palier invalides");
  return out;
}

export function TierEditor({ tiers, onChange, prefix }) {
  const upd = (i, k, v) => onChange(tiers.map((t, j) => (j === i ? { ...t, [k]: v } : t)));
  return (
    <div className="flex flex-col gap-3">
      {tiers.map((t, i) => (
        <div key={i} className="flex items-end gap-2">
          <div className="flex-1">
            <Field testID={`${prefix}-${i}-min`} label="Min (€)" inputMode="decimal" value={t.min} onChangeText={(v) => upd(i, "min", v)} />
          </div>
          <div className="flex-1">
            <Field testID={`${prefix}-${i}-max`} label="Max (€)" inputMode="decimal" value={t.max} onChangeText={(v) => upd(i, "max", v)} placeholder="∞" />
          </div>
          <div className="w-[84px]">
            <Field testID={`${prefix}-${i}-percent`} label="%" inputMode="decimal" value={t.percent} onChangeText={(v) => upd(i, "percent", v)} />
          </div>
          {tiers.length > 1 && (
            <button
              type="button"
              aria-label="Supprimer le palier"
              data-testid={`${prefix}-${i}-remove`}
              onClick={() => onChange(tiers.filter((_, j) => j !== i))}
              className="focus-ring flex h-12 w-11 items-center justify-center rounded-xl text-[#EB5757] hover:bg-[#EB5757]/10"
            >
              <Trash2 className="h-5 w-5" />
            </button>
          )}
        </div>
      ))}
      <Button
        testID={`${prefix}-add-button`}
        title="Ajouter un palier"
        icon={Plus}
        variant="ghost"
        onClick={() => onChange([...tiers, { min: tiers.length ? tiers[tiers.length - 1].max : "0", max: "", percent: "" }])}
      />
    </div>
  );
}
